module.exports = __webpack_public_path__ + "res/dummy_reels_sp4.72dc5ac08907e355e87af7aead7b113d.mp4";